import { useField } from "formik";

const FormikInputNonReq = ({ ...props }) => {
  const [field] = useField(props);

  return (
    <div className="field-container non-req">
      <input
        {...field}
        {...props}
      />
      
      
    </div>
  );
};
export default FormikInputNonReq;